// Tiny event bus to notify the UI whenever realtime sync invalidates data.
type Listener = (table: string) => void;

const listeners = new Set<Listener>();

export const realtimeBus = {
  emit(table: string) {
    listeners.forEach((l) => {
      try { l(table); } catch { /* ignore */ }
    });
  },
  subscribe(fn: Listener) {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};
